<template>
  <b-container>
    <!-- <Loading v-if="isLoading" :active.sync="isLoading"></Loading> -->
    <b-card class="page-body" body-class="has-footer">
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center mb-4">
          <img class="header-img" src="../../assets/images/logo-beo.svg">
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h1 class="page-greetings">
            Text Translation
          </h1>
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            INPUT FORM
          </h4>
        </CCol>
      </CRow>
      <div class="content">
        <CRow>
          <CCol col="12" lg="6">
            <label class="textarea-input" for="input-text">Masukkan Teks:</label>
            <textarea id="input-text"
              class="sm-input"
              placeholder="Masukkan teks yang akan di analisa di sini..."
              v-model="inputText"
              @input="assertMaxWords()"
              rows="4"
            ></textarea>
            <label class="textarea-input" for="input-source">Pilih Bahasa Teks:</label>
            <b-form-select id="input-source" v-model="inputSource" :options="optSource"/>
          </CCol>
          <CCol col="12" lg="6">
            <label class="textarea-input" for="output-text">
              <b-spinner v-if="isLoading" variant="primary" label="Spinning"></b-spinner> Translasi Indonesia:
            </label>
            <textarea id="output-text"
              class="sm-input"
              placeholder="Hasil Translasi"
              v-model="processedText"
              rows="4"
              disabled
            ></textarea>
          </CCol>
          <!-- <CCol col="12" class="form-button">
            <div class="sm-nav-wrapper">
              <div class="bottom-router">
                <router-link :to="{}" @click.native="onClickSubmit" class="btn">
                  <span><img src=""></span>Translate
                </router-link>
              </div>
            </div>
          </CCol> -->
        </CRow>
      </div>
      <!-- <CRow v-if="processedText.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <b-alert show variant="secondary">{{ processedText }}</b-alert>
        </CCol>
      </CRow> -->
      <!-- <CRow v-if="resultSummary.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            SUMMARY RESULT
          </h4>
        </CCol>
      </CRow>
      <div v-if="resultSummary.length > 0" class="content">
        <CRow>
          <CCol xm="12" class="d-flex justify-content-center my-2">
            <b-alert v-html="resultSummary" show></b-alert>
          </CCol>
        </CRow>
      </div>
      <CRow class="mt-5" v-if="resultNER.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            KEYWORDS
          </h4>
        </CCol>
      </CRow>
      <div v-if="resultNER.length > 0" class="content">
        <CRow>
          <div class="col-12">
            <b-table small
              :fields="fields"
              :items="resultNER"
            >
              <template #cell(index)="row">
                {{ row.index + 1 }}
              </template>
            </b-table>
          </div>
        </CRow>
      </div> -->
      <TheFooter></TheFooter>
    </b-card>
      <Modal v-if="showErrorModal" :foreground="true" :closeButton="false">
        <div slot="body">
          <label>{{errorLabel}}</label>
          <div class="btn-footer">
            <button class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
          </div>
        </div>
      </Modal>
  </b-container>
</template>
<script>
import TheFooter from  '../TheFooter';
import Modal from  '../Modal';
// import moment from 'moment';

export default {
  name: 'Main',
  components: {
    TheFooter,
    Modal
  },
  data(){
    return {
      isLoading: false,
      showErrorModal: false,
      errorLabel: "Terjadi kesalahan pada server. Silahkan coba lagi.",
      errorReload: false,
      inputText: "",
      processedText: "",

      optSource: [
        {text: "English", value: "en"},
        {text: "Chinese", value: "zh"},
        {text: "Arabic", value: "ar"},
      ],
      inputSource: "en",
      // fields: [
      //     { key: 'index', label: '' },
      //     { key: 'category', label: 'Kategori' },
      //     { key: 'content', label: 'Konten' },
      // ],
      // resultSummary: "",
      // resultNER: []
    }
  },
  watch: {
    inputText(...args){
      this.debouncedSubmit(...args)
    }
  },
  created() {
    this.debouncedSubmit = this.$helper.debounce((newVal, oldVal) => {
      if(newVal == "") this.processedText = "";
      else this.onClickSubmit();
    }, 1000);
  },
  methods: {
    assertMaxWords() {
      let inputString = this.inputText;
      inputString = inputString.replace(/(^\s*)|(\s*$)/gi,"");//exclude  start and end white-space
      inputString = inputString.replace(/[ ]{2,}/gi," ");//2 or more space to 1
      inputString = inputString.replace(/\n /,"\n"); // exclude newline with a start spacing
      inputString = inputString.split(' ').filter(function(str){return str!="";});
      let inputWordsCount = inputString.length;
      if(inputWordsCount > 30){
        inputString = inputString.slice(0, 30).join(" ");
        this.inputText = inputString;
      }
    },
    onClickSubmit(){
      this.isLoading = true
      let processUrl = "/translate"
      let payload = {
        text: this.inputText,
        target: null,
        source: this.inputSource
      }
      // let payload = new FormData()
      // payload.set('file', this.inputFile)

      this.$axios.post(processUrl, payload).then((response) => {
        if (response.status === 200 && response.data.success){
          this.processedText = response.data.data.text
        }
        else {
          this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          this.errorReload = false
          this.showErrorModal = true
        }
      })
      .catch(error => {
        if(error.response) this.errorLabel = error.response.data.reason
        else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
        this.errorReload = false
        this.showErrorModal = true
      })
      .finally(() => {
        this.isLoading = false
      })

      // Promise.all([runSummary, runNER]).then(() => {
      //   this.processedText = this.inputText
      //   // this.inputText = ""
      // })
      // .catch(error => {
      //   if(error.response) this.errorLabel = error.response.data.reason
      //   else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
      //   this.errorReload = false
      //   this.showErrorModal = true
      // })
      // .finally(() => {
      //   this.isLoading = false
      // })
    }
  }
}
</script>